import { Colors } from '@mercator-gcp/grout';

export type SavedStateColorScheme = {
  /** Solid background, used for the resting/selected state. */
  background: string;
  /** Lighter background tint, used for the unselected state of toggle tabs. */
  backgroundMuted: string;
  /** Border color. */
  border: string;
  /** Text & icon color. */
  foreground: string;
};

export const QualifiedColors: SavedStateColorScheme = {
  background: Colors.ForestGreen200,
  backgroundMuted: '#EBF5E6',
  border: Colors.SystemColorPositive,
  foreground: '#276C06',
};

export const MonitoringColors: SavedStateColorScheme = {
  background: '#FFF2D9',
  backgroundMuted: '#FFF8EC',
  border: Colors.SystemColorWarning,
  foreground: '#8C6400',
};

export const PassedColors: SavedStateColorScheme = {
  background: '#F8D2D4',
  backgroundMuted: '#FBE8E9',
  border: Colors.SystemColorNegative,
  foreground: '#99151C',
};
